(function(angular) {
    'use strict';
    angular
    .module('wtUi.filters', [])
    .filter('stripHtml', [function() {
        return function(_str, raw) {
            if (!raw) {
                return _str;
            }
            var str = _str;
            str = String(str).replace(/\<|\>|\"|\'|\&/g, function(matchStr) {
                /* eslint consistent-return:0 */
                switch (matchStr) {
                    case '<':
                        return '&lt;';
                    // break;
                    case '>':
                        return '&gt;';
                    // break;
                    case '\"':
                        return '&quot;';
                    // break;
                    case '\'':
                        return '&#39;';
                    // break;
                    case '&':
                        return '&amp;';
                    // break;
                    default:
                        break;
                }
            });
            return str;
        };
    }])
    .filter('limitToEllipsis', ['$filter', function($filter) {
        return function(input, limit, begin) {
            if (!input) {
                return input;
            }

            var _filtered = $filter('limitTo')(input, limit, begin);

            if (_filtered.length < input.length && typeof _filtered === 'string') {
                _filtered = _filtered.slice(0, _filtered.length - 1) + '\u2026';
            }

            return _filtered;
        };
    }])

    /**
     * Will search for the first word in input that is longer than limit. From this word input will be cut, that longest
     * word will be shortened to (limit - 1) characters and an ellipsis is added.
     */
    .filter('limitLongWordEllipsis', [function() {
        return function(input, limit) {
            if (!input || typeof input !== 'string' || typeof limit !== 'number') {
                return input;
            }

            var parts = input.split(' ');
            var partsLength = parts.length;
            var actionRequired = false;
            var i;
            var elementToModify;

            for (i = 0; i < partsLength; i++) {
                if (parts[i].length > limit) {
                    actionRequired = true;
                    break;
                }
            }

            if (!actionRequired) {
                return input;
            }

            parts.splice(i + 1);
            elementToModify = parts.length - 1;
            parts[elementToModify] = parts[elementToModify].substr(0, limit - 1);

            return parts.join(' ') + '\u2026';
        };
    }]);
})(window.angular);
